import axios from 'axios';

export const PORTAL_TOKEN_KEY = 'portal_token';
export const PORTAL_SITE_KEY = 'portal_site';
export const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const getPortalToken = () => localStorage.getItem(PORTAL_TOKEN_KEY);
export const setPortalToken = (t) => localStorage.setItem(PORTAL_TOKEN_KEY, t);
export const clearPortalToken = () => { localStorage.removeItem(PORTAL_TOKEN_KEY); localStorage.removeItem(PORTAL_SITE_KEY); };
export const getPortalSite = () => localStorage.getItem(PORTAL_SITE_KEY) || '';
export const setPortalSiteStored = (s) => (s ? localStorage.setItem(PORTAL_SITE_KEY, s) : localStorage.removeItem(PORTAL_SITE_KEY));

export const portalApi = axios.create({ baseURL: `${BACKEND}/api/portal` });
portalApi.interceptors.request.use((cfg) => {
  const t = getPortalToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  else delete cfg.headers.Authorization;
  // Site/plant filter: every data GET is narrowed to the selected site ('' = all sites)
  const site = getPortalSite();
  if (site && (cfg.method || 'get').toLowerCase() === 'get' && !String(cfg.url || '').startsWith('/auth')) {
    cfg.params = { ...(cfg.params || {}), site };
  }
  return cfg;
});
portalApi.interceptors.response.use((r) => r, (err) => {
  if (err.response?.status === 401 && getPortalToken() && !String(err.config?.url || '').includes('/auth/login')) {
    clearPortalToken();
    window.location.href = '/portal/login';
  }
  return Promise.reject(err);
});

// Direct file URL with token in the query string (PDFs / images opened in a new tab or <img>)
export const portalFileUrl = (path, withSite = false) => {
  const site = withSite ? getPortalSite() : '';
  return `${BACKEND}/api/portal${path}${path.includes('?') ? '&' : '?'}token=${encodeURIComponent(getPortalToken() || '')}${site ? `&site=${encodeURIComponent(site)}` : ''}`;
};

export const apiError = (e, fallback = 'Something went wrong') => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || fallback;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(' ');
  return d?.msg || fallback;
};

export const money = (v, dash = '—') => (v == null || isNaN(v)) ? dash : `$${Number(v).toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const hrs = (v) => (v == null ? '—' : `${Number(v).toFixed(Number(v) % 1 ? 1 : 0)}h`);
export const fmtDate = (d, opts = { month: 'short', day: 'numeric', year: 'numeric' }) => (d ? new Date(`${String(d).slice(0, 10)}T12:00:00`).toLocaleDateString('en-CA', opts) : '—');
export const fmtDay = (d) => fmtDate(d, { weekday: 'short', month: 'short', day: 'numeric' });
export const fmtRange = (a, b) => (a === b ? fmtDate(a) : `${fmtDate(a, { month: 'short', day: 'numeric' })} – ${fmtDate(b)}`);
export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleTimeString('en-CA', { hour: 'numeric', minute: '2-digit', timeZone: 'America/Toronto' }) : '—');
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString('en-CA', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'America/Toronto' }) : '—');
export const fmtClock = (t) => {
  if (!t) return '';
  const [h, m] = String(t).split(':').map(Number);
  if (isNaN(h)) return t;
  const ap = h >= 12 ? 'PM' : 'AM';
  return `${((h + 11) % 12) + 1}:${String(m || 0).padStart(2, '0')} ${ap}`;
};
export const sinceLabel = (iso) => {
  if (!iso) return '';
  const mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (mins < 60) return `${mins} min`;
  return `${Math.floor(mins / 60)}h ${mins % 60}m`;
};
